import React,  { useEffect, useState } from 'react';
import {  Typography, Box, Button,FormControl,
  InputLabel,
  MenuItem,
  Select, TextField } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import Slide from '@mui/material/Slide';
import { Icon } from '@genesis/ui-kit';
import { DataGrid } from '@genesis/ui-kit';

import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate } from "react-router-dom";
import SnackBar from '../../../../../Shared/Snackbar/Snackbar';
import classes from "./workschedules.module.scss";
import { constants } from '../../../../../Shared/Url/Constants';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const WorkSchedulesDialog = (props) => {
  const personDetails = useSelector((state) => state.person.personData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get('X_TKN');
  const history = useNavigate();
  const dialog = useToggle();
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
//  const [eventRowData , setEventRowData] = useState(props.data);
  const [wsListData, setWsListData] = useState(null); 

  useEffect(() => {
    dialog.show();
  }, []);

  useEffect(() => {
   //setEventRowData(props.data);
   getWorkSchedulesAPI();
  }, [props.data]);

  const dialogCLose = () => {
      dialog.hide();
      props.onCloseDialog();
  }

  const handleAlertNotifClose = () => {
      setAlertOpen({});
  };
  
  const getWorkSchedulesAPI = () => {
      let ruleId = props.data;
      axios({
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_WORKSCHEDULES_BY_RULEID}/${ruleId}`,
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' + token,
        },
      }).then((res) => {
        let resp = [];
        res.data.map((obj) => {
            let myObj = {};
            myObj.id = obj.recordSeq;
            myObj.displayDiv = obj.displayDiv;
            myObj.displayLoc = obj.displayLoc;
            myObj.dptNbr = obj.dptNbr;
            myObj.workSchedule = obj.workSchedule;
            resp.push(myObj);
        })
        setWsListData(resp);
      }).catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Something went wrong",
        })
      });


  }


  
  const columns = [
    { field: 'displayDiv', headerName: 'Division', width: "110" }, 
    { field: 'displayLoc', headerName: 'Locations', width: "80" },
    { field: 'dptNbr', headerName: 'Dept', width: "70" },  
    { field: 'workSchedule', headerName: 'Work Schedules', width: "240",
     renderCell: (params) => { 
    return(<div className={classes.gridcelltext}>{params.row.workSchedule}</div>)}},    
     
  ];

  

    return (
      <Box>
        <Dialog
          fullScreen
          open={dialog.open}
          title='Work Schedule(s)'
          onClose={dialogCLose}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
                width: '45%',
                maxWidth: '45%',
                minHeight: "100%",
                display:"flex",
                left:'28%',     
            },
        }}
        >
        <div style={{marginTop:"-30px"}}>
        <div className={classes.pagesubtitle} >Work Schedules Tagged To Rule {props.data}</div>
        <div style={{marginTop:"10px"}}>
        {wsListData && <Box  sx={{ height: 440, width: "98%", marginTop: 1,fontSize:14 }}>
                               <DataGrid 
                                getRowHeight={() => 'auto'}
                                variant='stripe'
                                columns= { columns} 
                                rows = {wsListData} 
                                disableSelectionOnClick={true}
                                components={{Footer: () => {return null}}} 
                                /> 
                              </Box>  }       
                              </div>
  
     
      </div>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </Dialog>
      </Box>
    );
  };
  
  export default WorkSchedulesDialog;